import { CardMedia, Stack } from '@mui/material'
import React from 'react'
import { Typography, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useTheme } from '@mui/material/styles'
import { MachineInvite } from '../../types/signup'
import { useContextHook } from '../../store/context'

interface newMachineProps {
  machines: MachineInvite[] | undefined
  machineCount: number
  individualElevation: boolean
}

const P2000IMAGE = 'p2000.png'
const L100IMAGE = 'P16_L100_front.png'

const NewMachines = (props: newMachineProps): JSX.Element => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { state } = useContextHook()

  const isScreenBelowLgBreakpoint = useMediaQuery(theme.breakpoints.down('lg'))

  const getMachineImage = (machine_image: string): { imageUrl: string; altText: string } => {
    const isDarkTheme = state.user?.is_darkmode

    if (machine_image === P2000IMAGE) {
      return { imageUrl: isDarkTheme ? '/machine_P2000.png' : '/machine_P2000.png', altText: 'mainview.p2000alt' }
    } else if (machine_image === L100IMAGE) {
      return { imageUrl: isDarkTheme ? '/machine_L100.png' : '/machine_L100.png', altText: 'mainview.l100alt' }
    } else {
      return { imageUrl: isDarkTheme ? '/machine_S100.png' : '/machine_S100.png', altText: 'mainview.s100alt' }
    }
  }
  return (
    <Stack
      sx={{
        width: '100%',
        minHeight: '100vh',
        backgroundColor: 'secondary.light',
        alignItems: 'center',
        pb: 5,
      }}
    >
      <Stack sx={{ mt: isScreenBelowLgBreakpoint ? '5%' : '10%', maxWidth: isScreenBelowLgBreakpoint ? '90%' : '60%' }}>
        <Typography variant="h3" sx={{ pb: 5 }}>
          {props.machineCount > 1 ? t('newmachine.congratulation') + 's' : t('newmachine.congratulation')}
        </Typography>
        <Stack
          sx={{
            backgroundColor: 'background.default',
            height: 'auto',
            boxShadow: 3,
            display: 'flex',
            p: 1,
          }}
        >
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'row',
              flexWrap: 'wrap',
              my: 5,
            }}
          >
            {props.machines &&
              props.machines.map((m, index) => (
                <Stack
                  sx={{
                    padding: 2,
                    border: 1.5,
                    borderRadius: 2,
                    borderColor: 'primary.main',
                    margin: 0.3,
                    position: 'relative',
                  }}
                >
                  {props.individualElevation && (
                    <Typography
                      variant="h1"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 1,
                      }}
                    >
                      {index + 1}
                    </Typography>
                  )}

                  <Stack
                    sx={{
                      filter: props.individualElevation ? 'blur(2px)' : 'undefined',
                    }}
                  >
                    <CardMedia
                      key={m.machine_name}
                      image={getMachineImage(m.machine_img).imageUrl}
                      alt={t(getMachineImage(m.machine_img).altText)}
                      component="img"
                      sx={{ width: props.machineCount > 1 ? '10vw' : '20vw' }}
                    />
                  </Stack>
                </Stack>
              ))}
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
export default NewMachines
